import React, { Fragment } from 'react';
import classNames from 'classnames';
const PipList = ({ rangeValuesSteps, offset }) => (<Fragment>
        {rangeValuesSteps.map((value, index) => (<div key={`pip_${index}`} className={classNames('StepRangeSlider__track-pip', {
            'StepRangeSlider__track-pip--active': offset >= parseInt(value),
        }, {
            'StepRangeSlider__track-pip--last': index === rangeValuesSteps.length - 1,
        })} style={{
            left: index === 0 ? `${parseInt(value)}%` : `calc(${parseInt(value)}% - 11px)`,
        }}/>))}
    </Fragment>);
export default PipList;
